import React from "react";
import { Layout, Typography } from "antd";

const { Header } = Layout;
const { Title, Text } = Typography;

const PageHeaderSection = () => {
  return (
    <Header
      style={{
        background: "#219737",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        padding: 0,
      }}
    >
      <div style={{ lineHeight: 0, marginTop: 5 }}>
        <Title level={4} style={{ color: "#fff", margin: 0 }}>
          ĐẠI HỘI CỔ ĐÔNG 2026
        </Title>
        <Text style={{ color: "#C7D2FE" }}>Phiên họp thường niên</Text>
      </div>

      <div style={{ color: "#E5E7EB", fontSize: 15 }}>
        25/02/2026 | 16:00 PM
      </div>
    </Header>
  );
};

export default PageHeaderSection;
